import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "app-report",
  "use": "app-report-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol viewBox=\"0 0 50 50\" id=\"app-report\"><defs><style>#app-report .cls-1{fill:#ffb93d;}#app-report .cls-2{fill:#fff;}</style></defs><title>资源 27</title><g id=\"app-report_图层_2\" data-name=\"图层 2\"><g id=\"app-report_图层_1-2\" data-name=\"图层 1\"><rect class=\"cls-1\" width=\"50\" height=\"50\" /><path class=\"cls-2\" d=\"M37.71,11.15H33.09V10H29.63v1.15H20.4V10H16.93v1.15H12.3a1.15,1.15,0,0,0-1.15,1.15V38.85A1.15,1.15,0,0,0,12.3,40H37.7a1.15,1.15,0,0,0,1.15-1.15V12.3a1.13,1.13,0,0,0-1.13-1.15ZM17.06,21.59l16.16-.1,0,2.31-16.16.1Zm0,4.61,16.16-.1,0,2.31-16.16.1Zm0,6.93,0-2.31,16.16-.1,0,2.31ZM36.55,17.48H13.47V16.11H36.55Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/app-report.svg
// module id = 5min
// module chunks = 264